import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../errors/responses';
import { Category, EffectiveDate, Manufacturer, Product } from './catalog/types';
import { Company } from './companies';
import { Partner } from './partners';

const c = initContract();

export const ExclusiveFilters = z.object({
  id: z.string(),
  daasCatalogItem: Product,
  manufacturer: Manufacturer,
  category: Category,
  partner: Partner,
  company: Company.optional(),
  effectiveDate: EffectiveDate
});

export type ExclusiveFilters = z.infer<typeof ExclusiveFilters>;

const SingularExclusiveFilterRequest = z.object({
  daasCatalogItemId: z.string(),
  manufacturerId: z.string(),
  categoryId: z.string(),
  companyId: z.string().optional(),
  partnerId: z.string(),
  effectiveDate: EffectiveDate
});

const ExclusiveFiltersRequest = z.object({
  customerIds: z.array(z.string()).optional(),
  mspIds: z.array(z.string())
});

export default c.router({
  getFilters: {
    method: 'GET',
    path: '/exclusivefilters',
    responses: {
      200: z.object({
        items: z.array(ExclusiveFilters)
      }),
      ...failedResponses
    }
  },
  createFilter: {
    method: 'POST',
    path: '/exclusivefilters',
    responses: {
      200: ExclusiveFilters,
      ...failedResponses
    },
    body: SingularExclusiveFilterRequest
  },
  createFiltersForProduct: {
    method: 'POST',
    path: '/exclusivefilters/catalogitems/:id',
    responses: {
      200: ExclusiveFilters,
      ...failedResponses
    },
    body: ExclusiveFiltersRequest
  },
  getFilter: {
    method: 'GET',
    path: '/exclusivefilters/:id',
    responses: {
      200: z.array(ExclusiveFilters),
      ...failedResponses
    }
  },
  deleteFilter: {
    method: 'DELETE',
    path: '/exclusivefilters/:id',
    responses: {
      200: z.undefined(),
      ...failedResponses
    },
    body: z.undefined()
  }
});
